<template>
  <div>
    <Account />
  </div>
</template>

<script>
import Account from '@/components/Account/Account';

export default {
  name: 'AccountPage',
  components: {
    Account,
  },
};
</script>
